import { render, staticRenderFns } from "./UniversityPage.vue?vue&type=template&id=5146513c"
import script from "./UniversityPage.vue?vue&type=script&lang=js"
export * from "./UniversityPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports